import Clipboard from '@bo-assets/icon/common/icon__copy-clipboard.svg';
import { onCopyToClipboard } from '@ecp/common/src/utils/utils';
import DragAndDropHandle from '@bo-assets/icon/common/icon__lnb-handle.svg';
import noImage from '@bo-assets/icon/common/icon__no-image.png';
import eyeOn from '@bo-assets/icon/common/icon-eye-on.png';
import eyeOff from '@bo-assets/icon/common/icon-eye-off.png';
import authApi from '@bo-apis/common/authApi';

const IB_Preset = {
  // 날짜 시간 포멧
  YMD: {
    Type: 'Date',
    Align: 'Center',
    Width: 110,
    Format: 'yyyy-MM-dd',
    DataFormat: 'yyyyMMdd',
    EditFormat: 'yyyyMMdd',
    Size: 8,
    EmptyValue: "<span style='color:#AAA'>년,월,일 순으로 숫자만 입력해 주세요.</span>",
  },
  YM: {
    Type: 'Date',
    Align: 'Center',
    Width: 80,
    Format: 'yyyy-MM',
    DataFormat: 'yyyyMM',
    EditFormat: 'yyyyMM',
    Size: 6,
    EmptyValue: "<span style='color:#AAA'>년,월 순으로 숫자만 입력해 주세요.</span>",
  },
  MD: {
    Type: 'Date',
    Align: 'Center',
    Width: 60,
    Format: 'MM-dd',
    EditFormat: 'MMdd',
    DataFormat: 'MMdd',
    Size: 4,
    EmptyValue: "<span style='color:#AAA'>월,일 순으로 숫자만 입력해 주세요.</span>",
  },
  HMS: {
    Type: 'Date',
    Align: 'Center',
    Width: 70,
    Format: 'HH:mm:ss',
    EditFormat: 'HHmmss',
    DataFormat: 'HHmmss',
    Size: 8,
    EmptyValue: "<span style='color:#AAA'>시,분,초 순으로 8개 숫자만 입력해 주세요.</span>",
  },
  HM: {
    Type: 'Date',
    Align: 'Center',
    Width: 70,
    Format: 'HH:mm',
    EditFormat: 'HHmm',
    DataFormat: 'HHmm',
    Size: 6,
    EmptyValue: "<span style='color:#AAA'>시,분 순으로 4개 숫자만 입력해 주세요.</span>",
  },
  YMDHMS: {
    Type: 'Date',
    Align: 'Center',
    Format: 'yyyy-MM-dd HH:mm:ss',
    Width: 150,
    EditFormat: 'yyyyMMddHHmmss',
    DataFormat: 'yyyyMMddHHmmss',
    Size: 14,
    EmptyValue: "<span style='color:#AAA'>숫자만 입력(ex:20190514153020)</span>",
  },
  YMD12HMS: {
    Type: 'Date',
    Align: 'Center',
    Format: 'yyyy-MM-dd hh:mm',
    Width: 150,
    EditFormat: 'yyyyMMddHHmm',
    DataFormat: 'yyyyMMddHHmmss',
    Size: 14,
    EmptyValue: "<span style='color:#AAA'>숫자만 입력(ex:20190514153020)</span>",
  },
  YMDHM: {
    Type: 'Date',
    Align: 'Center',
    Format: 'yyyy-MM-dd HH:mm',
    Width: 150,
    EditFormat: 'yyyyMMddHHmm',
    DataFormat: 'yyyyMMddHHmm',
    Size: 12,
    EmptyValue: "<span style='color:#AAA'>숫자만 입력(ex:201905141530)</span>",
  },
  MDY: {
    Type: 'Date',
    Align: 'Center',
    Format: 'MM-dd-yyyy',
    Width: 110,
    EditFormat: 'MMddyyyy',
    DataFormat: 'yyyyMMdd',
    Size: 8,
    EmptyValue: "<span style='color:#AAA'>월,일,년 순으로 숫자만 입력해 주세요.</span>",
  },
  DMY: {
    Type: 'Date',
    Align: 'Center',
    Format: 'dd-MM-yyyy',
    Width: 110,
    EditFormat: 'ddMMyyyy',
    DataFormat: 'yyyyMMdd',
    Size: 8,
    EmptyValue: "<span style='color:#AAA'>일,월,년 순으로 숫자만 입력해 주세요.</span>",
  },
  LOCAL_DATE_TIME_YMD: {
    Type: 'Date',
    Align: 'Center',
    Width: 110,
    Format: 'yyyy-MM-dd',
    DataFormat: 'yyyyMMddHHmmss',
    EditFormat: 'yyyyMMddHHmmss',
    Size: 8,
    EmptyValue: "<span style='color:#AAA'>숫자만 입력(ex:201905141530)</span>",
  },
  LOCAL_DATE_TIME_YMD2: {
    Type: 'Date',
    Align: 'Center',
    Width: 110,
    Format: 'yyyy-MM-dd',
    DataFormat: 'yyyyMMddHHmmss',
    Size: 14,
    EmptyValue: "<span style='color:#AAA'>숫자만 입력(ex:201905141530)</span>",
  },

  // 숫자 포멧
  Integer: {
    Type: 'Int',
    Align: 'Right',
    Format: '#,##0',
    Width: 100,
  },
  NullInteger: {
    Type: 'Int',
    Align: 'Right',
    Format: '#,###',
    Width: 100,
  },
  Float: {
    Type: 'Float',
    Align: 'Right',
    Format: '#,##0.######',
    Width: 100,
  },
  NullFloat: {
    Type: 'Float',
    Align: 'Right',
    Format: '#,###.######',
    Width: 100,
  },
  Percent: {
    Type: 'Int',
    Align: 'Right',
    Format: '#,##0.###\\%',
    Width: 100,
  },
  Currency: {
    Type: 'Float',
    Align: 'Right',
    Format: '#,##0원',
    Width: 100,
  },

  // 기타포멧
  IdNo: {
    Type: 'Text',
    Align: 'Center',
    CustomFormat: 'IdNo',
  },
  SaupNo: {},
  PostNo: {},
  CardNo: {},
  PhoneNo: {},
  Number: {},

  // ibsheet7 migration
  // Popup,PopupEdit
  Popup: {
    Type: 'Text',
    Width: 100,
    Align: 'Center',
    Button:
      'data:image/svg+xml;base64,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',
  },
  // Status Type
  STATUS: {
    Type: 'Text',
    Align: 'Center',
    Width: 50,
    Formula: "Row.Deleted ? 'D' : Row.Added ? 'I' : Row.Changed ? 'U' : 'R'",
    Format: {
      I: '입력',
      U: '수정',
      D: '삭제',
      R: '',
    },
  },
  // DelCheck Type
  DelCheck: {
    Type: 'Bool',
    Width: 50,
    OnClick: (evtParam) => {
      //부모가 체크되어 있는 경우 더 이상 진행하지 않는다.
      var chked = !evtParam.row[evtParam.col];
      var prows = evtParam.sheet.getParentRows(evtParam.row);
      if (!chked && prows[0] && prows[0][evtParam.col]) return true;
    },
    OnChange: (evtParam) => {
      var chked = evtParam.row[evtParam.col];
      //신규행에 대해서는 즉시 삭제한다.
      if (evtParam.row.Added) {
        setTimeout(function () {
          evtParam.sheet.removeRow(evtParam.row);
        }, 30);
      } else {
        //행을 삭제 상태로 변경
        evtParam.row.Deleted = chked;
        //자식행 추출
        var rows = evtParam.sheet.getChildRows(evtParam.row);
        rows.push(evtParam.row);

        //모두 체크하고 편집 불가로 변경
        for (var i = 0; i < rows.length; i++) {
          var row = rows[i];
          evtParam.sheet.setValue(row, evtParam.col, chked, false, true);
          row.CanEdit = !evtParam.row[evtParam.col];
          if (!row[evtParam.col + 'CanEdit']) {
            row[evtParam.col + 'CanEdit'] = true;
          }
          evtParam.sheet.refreshRow(row);
        }
      }
    },
  },
  TreeSumFormula: (fr) => {
    let sum = 0;

    if (fr.Row.childNodes.length) {
      for (let r = fr.Row.firstChild; r; r = r.nextSibling) {
        sum += r[fr.Col]; // 삭제 행, 빈 값, null 값을 제거하고 계산하고 싶은 경우 조건 변경
      }
    } else {
      fr.Row[fr.Col + 'CanEdit'] = 1;

      return fr.Row[fr.Col];
    }

    return sum;
  },
  TreeAvgFormula: (fr) => {
    let avg = 0,
      sum = 0,
      count = 0;

    if (fr.Row.childNodes.length) {
      for (let r = fr.Row.firstChild; r; r = r.nextSibling) {
        // 삭제 행, 빈 값, null 값을 제거하고 계산하고 싶은 경우 조건 변경
        sum += r[fr.Col];
        count++;
        avg = count && sum / count;
      }
    } else {
      fr.Row[fr.Col + 'CanEdit'] = 1;

      return fr.Row[fr.Col];
    }

    return avg;
  },
  TreeCountFormula: (fr) => {
    let count = 0;

    if (fr.Row.childNodes.length) {
      for (let r = fr.Row.firstChild; r; r = r.nextSibling) {
        // 삭제 행, 빈 값, null 값을 제거하고 계산하고 싶은 경우 조건 변경
        fr.Row[fr.Col + 'Format'] = '#,##0'; // 포맷 변경
        count++;
      }
    } else {
      fr.Row[fr.Col + 'CanEdit'] = 1;

      return fr.Row[fr.Col];
    }

    return count;
  },
  TreeMaxFormula: (fr) => {
    let max = Number.MIN_VALUE;

    if (fr.Row.childNodes.length) {
      for (let r = fr.Row.firstChild; r; r = r.nextSibling) {
        // 삭제 행, 빈 값, null 값을 제거하고 계산하고 싶은 경우 조건 변경
        if (max < r[fr.Col]) {
          max = r[fr.Col];
        }
      }
    } else {
      fr.Row[fr.Col + 'CanEdit'] = 1;

      return fr.Row[fr.Col];
    }

    return max;
  },
  TreeMinFormula: (fr) => {
    let min = Number.MAX_VALUE;

    if (fr.Row.childNodes.length) {
      for (let r = fr.Row.firstChild; r; r = r.nextSibling) {
        // 삭제 행, 빈 값, null 값을 제거하고 계산하고 싶은 경우 조건 변경
        if (min > r[fr.Col]) {
          min = r[fr.Col];
        }
      }
    } else {
      fr.Row[fr.Col + 'CanEdit'] = 1;

      return fr.Row[fr.Col];
    }

    return min;
  },
};

const Default_PeriodStatus = {
  Header: '기간상태',
  Type: 'Text',
  Name: 'periodStatus',
  MinWidth: 80,
  Width: 100,
  CanEdit: false,
  CanSort: false,
  Align: 'Center',
  Formula: ({ Row: { periodStatus } }) => {
    if (periodStatus?.includes('종료') || periodStatus === 'done') {
      return '기간 종료';
    } else if (periodStatus?.includes('전') || periodStatus === 'before') {
      return '기간 전';
    }
    return '기간 중';
  },
};

export const Custom_Preset = {
  DragAndDropIcon: {
    Header: {
      Value: ' ',
    },
    Type: 'Text',
    Name: 'DragAndDropIcon',
    MinWidth: 46,
    MaxWidth: 46,
    IconWidth: 46,
    Class: 'grid__drag-and-drop',
    Cursor: 'grab',
    CanEdit: false,
    CanExport: false,
    Icon: DragAndDropHandle,
  },
  CheckBox: {
    Header: { Value: '', Align: 'Center', Class: 'grid__checkbox' },
    Type: 'Bool',
    Name: 'CHK',
    Align: 'Center',
    Width: 60,
    MaxWidth: 60,
    CanSort: false,
    CanExport: false,
    ColMerge: false,
    NoChanged: true,
  },
  SEQ: {
    Header: '번호',
    Type: 'Text',
    Width: 72,
    MaxWidth: 72,
    Align: 'Center',
    Name: 'SEQ',
    CanSort: false,
    CanEdit: false,
    CanExport: false,
  },
  RowIndex: {
    Header: '번호',
    Type: 'Text',
    Width: 72,
    MaxWidth: 72,
    Align: 'Center',
    Name: 'rowIndex',
    CanSort: false,
    CanEdit: false,
    CanExport: false,
  },
  UseYn: {
    Header: '사용상태',
    Type: 'Radio',
    Name: 'useYn',
    Key: 'use_yn',
    Enum: '|사용|미사용',
    EnumKeys: '|Y|N',
    MinWidth: 112,
    MaxWidth: 240,
    Width: 159,
    Align: 'Center',
  },
  CreatorId: {
    Header: '등록자',
    Type: 'Text',
    Align: 'Center',
    Name: 'creatorId',
    Key: 'rgr_id',
    MinWidth: 100,
    Width: 194,
    CanEdit: false,
  },
  CreatorName: {
    Header: '등록자',
    Type: 'Text',
    Align: 'Center',
    Name: 'creatorName',
    Key: 'rgr_nm',
    MinWidth: 100,
    Width: 194,
    CanEdit: false,
  },
  CreateDate: {
    Header: '등록일시',
    ...IB_Preset.YMD12HMS,
    Name: 'createDate',
    Key: 'reg_dtime',
    MinWidth: 132,
    Width: 132,
    CanEdit: false,
    EmptyValue: '',
  },
  UpdateId: {
    Header: '최종수정자',
    Type: 'Text',
    Align: 'Center',
    Name: 'updaterId',
    Key: 'uptr_id',
    MinWidth: 100,
    Width: 194,
    CanEdit: false,
  },
  UpdateName: {
    Header: '최종수정자',
    Type: 'Text',
    Align: 'Center',
    Name: 'updaterName',
    Key: 'uptr_nm',
    MinWidth: 100,
    Width: 194,
    CanEdit: false,
  },
  UpdateDate: {
    Header: '최종수정일시',
    ...IB_Preset.YMD12HMS,
    Name: 'updateDate',
    Key: 'upt_dtime',
    MinWidth: 132,
    Width: 132,
    RelWidth: true,
    CanEdit: false,
    EmptyValue: '',
  },
  ErrorDescription: {
    Header: '오류내역',
    Type: 'Text',
    Align: 'Left',
    Name: 'ErrorDescription',
    MinWidth: 160,
    Width: 213,
    RelWidth: true,
    CanEdit: false,
    CanSort: false,
  },
  DropDown: {
    Type: 'Enum',
    MinWidth: 94,
    MaxWidth: 240,
    Width: 159,
    EmptyValue: '선택',
  },
  RadioGroup: {
    Type: 'Radio',
    MinWidth: 112,
    MaxWidth: 240,
    Width: 159,
    Align: 'Center',
    EmptyValue: '선택',
  },
  CheckboxGroup: {
    Type: 'Radio',
    Range: true,
    MinWidth: 112,
    MaxWidth: 260,
    Width: 260,
    Align: 'Center',
  },
  DateYm: {
    ...IB_Preset.YM,
    MinWidth: 110,
    Width: 110,
    CanEdit: true,
  },
  DateYmReadOnly: {
    ...IB_Preset.YM,
    MinWidth: 80,
    Width: 80,
    CanEdit: false,
  },
  Date: {
    ...IB_Preset.YMD,
    MinWidth: 134,
    Width: 134,
    CanEdit: true,
  },
  DateReadOnly: {
    ...IB_Preset.YMD,
    MinWidth: 150,
    Width: 150,
    CanEdit: false,
  },
  EndDate: {
    ...IB_Preset.YMD12HMS,
    Align: 'Center',
    EditFormat: 'yyyyMMdd',
    Format: 'yyyy-MM-dd',
    MinWidth: 134,
    Width: 134,
    Button: 'Html',
    ButtonText: "<i class='IBDateRight IBSideRight' style='margin-right:3px; width:100%'></i>",
    OnClickSide: (evt) => {
      const calOption = {
        Date: evt.row[evt.col] || '',
        Format: 'yyyyMMdd',
        Texts: { Clear: '종료일없음' },
        Buttons: 2,
        OnSave: (time) => {
          //종료일 없음 선택시
          if (time === '') {
            evt.sheet.setValue(evt.row, evt.col, new Date(2999, 11, 31));
          } else {
            evt.sheet.setValue(evt.row, evt.col, time);
          }
        },
      };
      //시트 내에 우측 달력 버튼 클릭시
      evt.sheet.showCalendar(evt.row, evt.col, calOption);

      return true;
    },
  },
  DateTime: {
    ...IB_Preset.YMD12HMS,
    MinWidth: 172,
    Width: 172,
    CanEdit: true,
  },
  DateTimeReadOnly: {
    ...IB_Preset.YMD12HMS,
    MinWidth: 132,
    Width: 132,
    CanEdit: false,
  },
  ClipboardText: {
    Type: 'Text',
    Align: 'Center',
    MinWidth: 108,
    Width: 138,
    Icon: Clipboard,
    IconWidth: 22,
    Cursor: 'pointer',
    TextStyle: 4,
    Class: 'grid__icon-text',
    OnClickSide: async (event) => {
      const value = event.sheet.getValue(event.row, event.col);
      value && (await onCopyToClipboard(value));
    },
  },
  ClipboardTextToast: (callback) => ({
    Type: 'Text',
    Align: 'Center',
    MinWidth: 108,
    Width: 138,
    Icon: Clipboard,
    IconWidth: 22,
    Cursor: 'pointer',
    TextStyle: 4,
    Class: 'grid__icon-text',
    OnClickSide: async (event) => {
      const value = event.sheet.getValue(event.row, event.col);
      if (value) {
        const result = await onCopyToClipboard(value);
        result && callback?.();
      }
    },
  }),
  ImageIcon: {
    Type: 'Text',
    MinWidth: 68,
    MaxWidth: 68,
    IconWidth: 68,
    Class: 'grid__image-link',
    CanEdit: false,
    CanExport: false,
    IconFormula: (param) => {
      // Def.Row 설정 추가, CanExport: false 필수
      return param?.Row?.['src'] || noImage;
    },
    OnClickSide: (event) => {
      const dialog = {
        Body: `<div style='width: 150px; height: 150px;'><img src='${event.row.src}' alt='imageIcon' style='object-fit: contain; width: 100%; height: 100%;'/></div>`,
        Modal: false,
        MinHeight: 150,
        MaxHeight: 150,
        MinWidth: 150,
        MaxWidth: 150,
      };
      event.sheet.showDialog(event.row, event.col, dialog);

      return true;
    },
  },
  ShowHiddenIcon:(name)=> ({
    Type: 'Text',
    CanEdit: false,
    CanExport: false,
    IconFormula: (fr)=>{
      return fr.Sheet.getValue(fr.Row,`${fr.Col}IconYn`) ? eyeOff: eyeOn      
    },
    OnClickSide: async (event) => {
      if (event.sheet.getValue(event.row,`${name}IconYn`)){
        event.sheet.setValue(event.row, `${name}IconYn`,false); 
        if(name === 'ordererNameVIP'){          
          event.sheet.setValue(event.row, 'ordererName', event.row['ordererNameOrig']);
        }else{
          event.sheet.setValue(event.row, event.col, event.row[`${name}Orig`]);
        }        
      } else {          
        event.sheet.setValue(event.row, `${name}IconYn`,true);
        if(name === 'ordererNameVIP'){          
          const {result} = await authApi.getDecrypt({ str: event.row['ordererNameEncrypt']})          
          event.sheet.setValue(event.row, 'ordererName', result);
        }else{          
          const {result} = await authApi.getDecrypt({ str: event.row[`${name}Encrypt`]});
          event.sheet.setValue(event.row, event.col, result);
        }   
      }
    },
  }),
  UserId: {
    Type: 'Text',
    Align: 'Center',
    MinWidth: 100,
    Width: 194,
    CanEdit: false,
  },
  UserName: {
    Type: 'Text',
    Align: 'Center',
    MinWidth: 100,
    Width: 156,
    CanEdit: false,
  },
  PhoneNo: {
    Type: 'Text',
    Align: 'Center',
    MinWidth: 100,
    Width: 126,
    CanEdit: false,
  },
  MobileNo: {
    Type: 'Text',
    Align: 'Center',
    MinWidth: 100,
    Width: 142,
    CanEdit: false,
  },
  BusinessNo: {
    Type: 'Text',
    Align: 'Center',
    MinWidth: 100,
    Width: 142,
    CanEdit: false,
  },
  Code: {
    Type: 'Text',
    Align: 'Center',
    MinWidth: 100,
    Width: 138,
  },
  Status: {
    Type: 'Text',
    Align: 'Center',
    MinWidth: 100,
    Width: 181,
  },
  AccountNo: {
    Type: 'Text',
    Align: 'Center',
    MinWidth: 100,
    Width: 132,
  },
  LinkText: {
    Type: 'Text',
    MinWidth: 140,
    Width: 140,
    Cursor: 'pointer',
    TextStyle: 4,
    OnClick: ({ row: { Kind } }) => {
      if (Kind === 'Header') {
        return true;
      }
      //navigateWithSearchOption(url, searchOption, gridRef)
    },
  },
  DetailPeriodStatus: {
    ...Default_PeriodStatus,
    TextColorFormula: ({ Row: { periodStatus } }) => {
      if (periodStatus?.includes('중') || periodStatus === 'ing') {
        return '#333333';
      }
      return '#E10808';
    },
  },
  ListPeriodListStatus: {
    ...Default_PeriodStatus,
    TextColorFormula: ({ Row: { periodStatus } }) => {
      if (periodStatus?.includes('중') || periodStatus === 'ing') {
        return '#333333';
      }
      return '#CCCCCC';
    },
  },
};

export const Left_Presets = [Custom_Preset.CheckBox, Custom_Preset.RowIndex];
export const Left_UnPaged_Presets = [Custom_Preset.CheckBox, Custom_Preset.SEQ];
export const Left_DnD_Presets = [Custom_Preset.DragAndDropIcon, Custom_Preset.CheckBox, Custom_Preset.RowIndex];

export const System_Presets = [
  Custom_Preset.UseYn,
  Custom_Preset.CreatorId,
  Custom_Preset.CreateDate,
  Custom_Preset.UpdateId,
  Custom_Preset.UpdateDate,
];

export const System_Base_Presets = [
  Custom_Preset.CreatorName,
  Custom_Preset.CreateDate,
  Custom_Preset.UpdateName,
  Custom_Preset.UpdateDate,
];

export const System_Presets_New = [Custom_Preset.UseYn, ...System_Base_Presets];

export const Editable_System_Presets = [...System_Presets, Custom_Preset.ErrorDescription];
export const Editable_System_Presets_New = [...System_Presets_New, Custom_Preset.ErrorDescription];

export const Default_Cfg = {
  // DebugOption: 'error, problem, info, check, ioerror, io',
  IgnoreFocused: true,
  FitWidth: true,
  CanDrag: false,
  SearchMode: 0,
  MessageWidth: 300,
  HeaderCheck: 1,
  RequiredPosition: 'Right',
  InfoRowConfig: {
    Visible: 0,
  },
  GetByDataFormat: false,
  HeaderSortMode: 3,
  HeaderSortActionMode: 1,
  CustomScroll: 3,
  UseHeaderSortCancel: true,
  HeaderMerge: 3,
  WheelScrollCount: 1,
  Alternate: 0,
  AutoRowHeight: false,
  NoTreeLines: 1,
  ColorState: 55,
  RangeEnumIconLeft: true,
  FilterEnumIconLeft: true,
};

export const Default_Editable_Def = {
  Col: {
    CanEdit: 1,
    TipClass: 'tip-class',
  },
  Row: {
    Height: 44,
  },
  Header: {
    Align: 'Center',
    TextStyle: 1,
    Height: 44,
    HeaderCheck: 1,
  },
};

export const Default_UnEditable_Def = {
  ...Default_Editable_Def,
  Col: {
    CanEdit: 2,
  },
};

export default IB_Preset;
